module.exports = " <hgroup _v-736b2dc9=\"\"> <h1 _v-736b2dc9=\"\">{{heading}}</h1> <h2 v-if=heading2 _v-736b2dc9=\"\">{{heading2}}</h2> <h3 v-if=subheading class=color-tint _v-736b2dc9=\"\">{{subheading}}</h3> </hgroup> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-736b2dc9!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/HeaderGroup.vue
// module id = 757
// module chunks = 2